<template>
    <Dialog v-model:visible="visible" modal :draggable="false" header="Zaakceptuj regulamin"
            class="accept-terms-dialog" :closable="false">
        <div>
            <div>
                <h2 class="terms-rodo-header text-6xl">
                    {{ terms[0].title }}
                </h2>
                <p v-html="terms[0].content" class="terms-rodo-text text-left"></p>
            </div>
            <div class="flex justify-content-center gap-3">
                <CustomButton label="Zaakceptuj" class="mt-3"
                              bgColor="var(--secondary-color)" color="var(--surface-a)"
                              @click="accept" />
                <CustomButton label="Wyloguj" class="mt-3"
                              @click="reject"/>
            </div>
        </div>
    </Dialog>
</template>

<script>
    import axios from "axios";
    import Dialog from "primevue/dialog";
    import CustomButton from "@/components/form/CustomButton.vue";
    import {
        acceptTerms,
    } from "@/swagger/vue-api-client";

    export default {
        name: "AcceptTermsDialog",

        components: {
            Dialog,
            CustomButton,
        },

        props: {
            modelValue: null,
            terms: null,
        },

        emits: ["checkTerms"],

        methods: {
            accept() {
                acceptTerms({type: this.terms[0].type})
                    .then(() => {
                        this.visible = false;
                        this.$emit("checkTerms");
                    });
            },
            reject() {
                localStorage.removeItem("token");
                localStorage.removeItem("role");
                localStorage.removeItem("roles");
                localStorage.removeItem("name");
                const uninterceptedAxiosInstance = axios.create();
                uninterceptedAxiosInstance.post(process.env.VUE_APP_API_URL + "/token/logout", undefined, { withCredentials: true })
                    .then(() => {
                        this.$router.push({name: "login"});
                        this.visible = false;
                    });
            },
        },

        computed: {
            visible: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },
    };
</script>

<style lang="scss">
    .accept-terms-dialog.p-dialog {
        width: 90%;
        .p-dialog-content {
            // height: 90vh;
            .terms-rodo-header {
                margin-top: 0;
                text-align: center;
            }
            .terms-rodo-text {
                margin-bottom: 2rem;
            }
        }
    }
</style>
